import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ShortProgramDescription = lazyWithPreload(
  () => import('./ShortProgramDescription'),
)
